export const buildMessageOriginalContent = (contentBeforeAiFeature: string | undefined): string | null =>
  contentBeforeAiFeature?.trim() ? contentBeforeAiFeature : null
